import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

// Import all components at the top
import Signup from "./pages/auth/signup";
import Login from "./pages/auth/login";
import Sidebar from "./component/sidebar";
import Navbar from "./component/navbar";

// Sales field agent
import SalesAgentDashboard from "./pages/salesagent/dashbaord";
import SalesCustomerDetails from "./pages/salesagent/customer";
import AddCustomer from "./pages/salesagent/addcustomer";
import ImportCustomerDetails from "./pages/salesagent/importcustomers";
import SalesReport from "./pages/salesagent/salesreport";
import OrderDetails from "./pages/salesagent/OrderDetails";
import SingleOrderDetails from "./pages/salesagent/singleorderdetails";
import FeedbackLogTable from "./pages/salesagent/feedback";
import ViewCustomer from "./pages/salesagent/viewcustomerdetails";
import OrderBulk from "./pages/salesagent/orderbulk";

//admin
import AdminDashboard from "./pages/admin";
import AdminCustomerDetails from "./pages/admin/admincustomer";
import AdminAddCustomer from "./pages/admin/admin-addcustomer";
import AdminViewCustomer from "./pages/admin/admin-viewuserdetails";
import AdminImportCustomerDetails from "./pages/admin/adminimport-customers";
import AdminProducts from "./pages/admin/adminviewproduct";
import AdminProductForm from "./pages/admin/admin-addproduct";
import AdminViewProductPage from "./pages/admin/adminviewallproduct";
import AdminOrderDetails from "./pages/admin/admin-vieworders";
import AdminOrderSummary from "./pages/admin/admin-orderdetails";
import AdminTransactions from "./pages/admin/admin-transactions";
import AdminVisitInfo from "./pages/admin/admin-visit-info";
import HotDealsPage from "./pages/admin/hotdeals";
import AdminCompareprice from "./pages/admin/adminCompareprice";
import MessagePanel from "./pages/admin/admin-inappmessage";

//sales supervisor
import SalesAgentPerformance from "./pages/salessupervisor";
import SalesSupervisorsOrderDetails from "./pages/salessupervisor/salessupervisor-orders";
import SalesSupervisorOrderSummary from "./pages/salessupervisor/salessupervisor-orderdetails";

//business
import BusinessDashboardCards from "./pages/business";
import BusinessAgentPerformance from "./pages/business/businessperformance";
import BusinessFeedbackTable from "./pages/business/Businessfeedback";


import TermsAndConditions from "./pages/privavy-policie";

function App() {
  const location = useLocation();

  // Paths where the Sidebar and Navbar should not be shown
  const excludedPaths = ["/", "/signup", "/login", "termsandconditions"]; // Exclude paths like login and signup
  
  const showNavbarAndSidebar = !excludedPaths.includes(location.pathname);

  return (
    <div className="flex min-h-screen">
      {/* Conditionally render Sidebar and Navbar */}
      {showNavbarAndSidebar && <Sidebar />}
      <div className={`flex-1 ${showNavbarAndSidebar ? 'p-6' : ''}`}>
        {showNavbarAndSidebar && <Navbar />}
        <Routes>
          <Route path="/" element={<Signup />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route path="/login" element={<Login />} />
          {/* Sales field agent */}
          <Route path="/SalesAgentDashboard" element={<SalesAgentDashboard />} />
          <Route path="/SalesCustomerDetails" element={<SalesCustomerDetails />} />
          <Route path="/SalesCustomerDetails/AddCustomer" element={<AddCustomer />} />
          <Route path="/SalesCustomerDetails/ImportCustomerDetails" element={<ImportCustomerDetails />} />
          <Route path="/SalesReport" element={<SalesReport />} />
          <Route path="/OrderDetails" element={<OrderDetails />} />
          <Route path="/OrderDetails/SingleOrderDetails/:id" element={<SingleOrderDetails />} />
          <Route path="/FeedbackLogTable" element={<FeedbackLogTable />} />
          <Route path="/SalesCustomerDetails/ViewCustomer/:id" element={<ViewCustomer />} />
          <Route path="/SalesCustomerDetails/OrderBulk/:id" element={<OrderBulk />} />
          {/* Admin routes */}
          <Route path="/AdminDashboard" element={<AdminDashboard />} />
          <Route path="/AdminCustomerDetails" element={<AdminCustomerDetails />} />
          <Route path="/AdminCustomerDetails/AdminViewCustomer/:id" element={<AdminViewCustomer />} />
          <Route path="/AdminCustomerDetails/AdminAddCustomer" element={<AdminAddCustomer />} />
          <Route path="/AdminCustomerDetails/AdminImportCustomerDetails" element={<AdminImportCustomerDetails />} />
          <Route path="/AdminProducts" element={<AdminProducts />} />
          <Route path="/AdminProducts/AdminProductForm" element={<AdminProductForm />} />
          <Route path="/AdminProducts/AdminViewProductPage" element={<AdminViewProductPage />} />
          <Route path="/AdminOrderDetails" element={<AdminOrderDetails />} />
          <Route path="/AdminOrderDetails/AdminOrderSummary/:id" element={<AdminOrderSummary />} />
          <Route path="/AdminTransactions" element={<AdminTransactions/>} />
          <Route path="/AdminVisitInfo" element={<AdminVisitInfo/>} />
          <Route path="/HotDealsPage" element={<HotDealsPage/>} />
          <Route path="/admincompareprice" element={<AdminCompareprice/>} />
          <Route path="/messagepanel" element={<MessagePanel/>} />
          {/* Sales supervisor */}
          <Route path="/SalesAgentPerformance" element={<SalesAgentPerformance />} />
          <Route path="/SalesSupervisorsOrderDetails" element={<SalesSupervisorsOrderDetails />} />
          <Route path="/SalesSupervisorsOrderDetails/SalesSupervisorOrderSummary/:id" element={<SalesSupervisorOrderSummary />} />
          {/* Business routes */}
          <Route path="/BusinessDashboardCards" element={<BusinessDashboardCards />} />
          <Route path="/BusinessAgentPerformance" element={<BusinessAgentPerformance />} />
          <Route path="/BusinessFeedbackTable" element={<BusinessFeedbackTable />} />
        </Routes>
      </div>
    </div>
  );
}

export default App;
